"use client";

import type React from "react";
import { forwardRef } from "react";
import styles from "./Button.module.scss";
import { ButtonProps } from "./Button.types";
import { trackEventWithCommonProps, EventType } from "@utils/eventTracker";
import { getLoginUrl } from "@utils/getLoginUrl";
import { handleLoginFlow } from "@utils/loginFlowHandler";

const Button = forwardRef<HTMLButtonElement, ButtonProps>(
  (
    {
      className,
      onButtonClick,
      children,
      variant = "",
      size = "md",
      isLoading,
      disabled,
      ariaLabel,
      link,
      loginlink,
      loginPopupConfig,
      segmentEventProps,
      ...props
    },
    ref
  ) => {
    const handleButtonClick = async () => {
      // Track segment event if props are provided
      if (segmentEventProps) {
        const { eventName, eventProperties = {}, pageType } = segmentEventProps;

        await trackEventWithCommonProps(eventName, EventType.TRACK_EVENT, {
          pageType: pageType,
          additionalProps: eventProperties,
        });
      }

      if (link) {
        window.location.href = link;
      }

      if (loginPopupConfig) {
        await handleLoginFlow(getLoginUrl(window.location.href), loginPopupConfig);
      }
      else if (loginlink) {
        window.location.href = getLoginUrl(window.location.href);
      }
      if (onButtonClick) {
        onButtonClick();
      }
    };

    return (
      <button
        className={`${styles.button} ${styles[variant]} ${styles[size]} ${
          className || ""
        }`}
        ref={ref}
        disabled={isLoading || disabled}
        onClick={handleButtonClick}
        aria-label={ariaLabel}
        {...props}
      >
        {isLoading ? <div className={styles.loadingSpinner} /> : null}
        {children}
      </button>
    );
  }
);

Button.displayName = "Button";

export default Button;
export { Button };
